import { clsx } from 'clsx';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Skeleton } from '@interxfi/design-system/components/loading/skeleton';
import type { AssetLogoSize } from '../asset-logo';
import styles from './asset-logo-with-label.module.scss';

interface AssetLogoWithLabelSkeletonProps {
  size?: AssetLogoSize;
}

export function AssetLogoWithLabelSkeleton({ size = 'small' }: AssetLogoWithLabelSkeletonProps) {
  return (
    <HorizontalStack blockAlign="center" className={clsx(styles.assetLogoWithLabel, styles.isSkeleton, `size-${size}`)} gap={2} wrap="nowrap">
      <Skeleton fillParent parentClassName={styles.logo} type="line" />
      <Skeleton fillParent parentClassName={styles.label} type="line" />
    </HorizontalStack>
  );
}
